import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useLocalDateTime } from '@/hooks/use-local-date-time'

export const LocalDateTime: FC<{ date: string; locale?: Locale; showDate?: boolean }> = ({
  date,
  locale,
  showDate = true,
}) => {
  const { formatTime } = useLocalDateTime()

  return (
    <span>
      {formatTime({
        date,
        locale,
        showDate,
      })}
    </span>
  )
}
